/**
 * Determines the type of user device based on the user agent string.
 *
 * @type {'m' | 't' | 'd'}
 * @description
 * - 'm': Mobile device (smartphones)
 * - 't': Tablet device
 * - 'd': Desktop device
 *
 * @remarks Uses navigator.userAgent for client-side detection
 * @returns {string} Device type identifier
 * @example
 * // On a mobile phone, returns 'm'
 * // On a tablet, returns 't'
 * // On a desktop, returns 'd'
 */
const UA = import.meta.client ? navigator.userAgent : ''
export const userDevice =
  /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
    UA
  )
    ? 'm'
    : /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(UA)
      ? 't'
      : 'd'
